import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const FlashMessage = ({ message, image }) => (
  <div className="flash-message-container">
    <img src={image} alt="flash icon" />
    <span>{message}</span>
  </div>
);

FlashMessage.propTypes = {
  message: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default class FlashMessageService {
  static getFlashRoot() {
    if (typeof document === 'undefined') {
      return null;
    }

    const flashRoot = document.getElementById('flash-root');
    if (flashRoot) {
      return flashRoot;
    }

    const root = document.getElementById('react');
    const container = document.createElement('div');
    container.setAttribute('id', 'flash-root');
    root.appendChild(container);
    return container;
  }

  static hide() {
    const flashRoot = FlashMessageService.getFlashRoot();
    if (flashRoot) {
      ReactDOM.unmountComponentAtNode(flashRoot);
    }
  }

  static show(message, image) {
    const flashRoot = FlashMessageService.getFlashRoot();
    if (flashRoot) {
      ReactDOM.render(
        <FlashMessage message={message} image={image} />,
        flashRoot,
      );
      setTimeout(FlashMessageService.hide, 8000);
    }
  }
}
